import * as React from "react";
import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, IconButton, MenuItem } from "@mui/material";
import globalStyles from "../../../../../styles/globalStyles.module.css";
import { isClientPreview } from "../../../../../utils/clientPreview";
import connectStyles from "./connectStore.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getStoreName,
  storeSelector,
} from "../../../../../redux/slices/storeSlice";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import shopifyAppLogo from "../../../../../assets/img/shopifyApp.png";
import { ReactComponent as StoreIcon } from "../../../../../assets/img/store.svg";
import { Add } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "55%",
  height: "720px",
  overflowY: "scroll",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  padding: "0 30px",
  borderRadius: "10px",
};

export default function NewConnectStoreModal({
  title,
  handleOpenFn,
  handleCloseFn,
  openState,
  setOpenState,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { addedStore } = useSelector(storeSelector);

  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
    if (addedStore?.store) {
      window.location.href = addedStore.store;
    }
  }, [addedStore, dispatch]);

  React.useEffect(() => {
    if (addedStore?.store) {
      dispatch(getStoreName(null));
    }
  }, [addedStore, dispatch]);

  return (
    <>
      {/* <img src={Chart} alt="" onClick={handleOpen} /> */}

      <>
        {title === "newUI" ? (
          <Button
            variant="lightblue"
            sx={{
              background: "#210C43",
              margin: 0,
              boxShadow: "none",
              ":hover": {
                background: "#210C43",
              },
              width: "80%",
              margin: "auto",
            }}
            className="w-full"
            onClick={handleOpen}
            endIcon={<Add />}
          >
            Add Stores
          </Button>
        ) : title === "connect_store" ? (
          <MenuItem
            sx={{
              fontSize: "14px",
              color: "#9d9d9d",
            }}
            onClick={handleOpenFn ? handleOpenFn : handleOpen}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifySelf: "center",
                  marginRight: "5px",
                }}
              ></div>{" "}
              <Button
                variant="lightblue"
                sx={{ borderRadius: "5px", width: "auto" }}
              >
                Connect Store
              </Button>
            </div>
          </MenuItem>
        ) : title !== "connect" ? (
          <MenuItem
            sx={{
              fontSize: "14px",
              color: "#9d9d9d",
            }}
            onClick={handleOpenFn ? handleOpenFn : handleOpen}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifySelf: "center",
                  marginRight: "5px",
                }}
              >
                {/* <MdOutlineStore size={16} style={{ color: "black" }} /> */}
                <StoreIcon width="16" height="16" />
              </div>{" "}
              <p style={{ fontWeight: 400 }}>Add stores</p>
            </div>
          </MenuItem>
        ) : (
          <Box
            onClick={handleOpenFn ? handleOpenFn : handleOpen}
            sx={{
              width: "80%",
              height: "40px",
              display: "flex",
              padding: "10px 20px",
              marginLeft: "10%",
              marginTop: "10px",
              alignItems: "center",
              justifyContent: "center",
              border: "1px dashed lightgray",
              borderRadius: "5px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#eeeeee",
              },
            }}
          >
            <AddBusinessIcon sx={{ color: "gray" }} />
            <MenuItem
              sx={{
                display: "flex",
                fontSize: "14px",
                fontWeight: "600",
                color: "gray",
                "&:hover": {
                  backgroundColor: "#eeeeee",
                },
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <div
                  style={{
                    display: "flex",
                    justifySelf: "center",
                    marginRight: "5px",
                  }}
                >
                  <MdOutlineStore size={16} style={{ color: "black" }} />
                </div>{" "} */}
                <p style={{ fontWeight: 400 }}>Add stores</p>
              </div>
            </MenuItem>
          </Box>
        )}
      </>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openState ? openState : open}
        onClose={handleCloseFn ? handleCloseFn : handleClose}
        closeAfterTransition
        // BackdropProps={{
        //   timeout: 500,
        // }}
        // BackdropProps={{
        //   style: {
        //     pointerEvents: "none", // This ensures that the backdrop is not clickable
        //   },
        // }}
      >
        <Fade in={openState ? openState : open}>
          <Box sx={style} className={`hide_scrollbar ${isClientPreview() ? connectStyles.sheet : ""}`}>
            {isClientPreview() ? (
              <div className={connectStyles.body}>
                <img src="https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png" alt="" className={connectStyles.logo} />
                <h2>Add a store</h2>
                <p className={connectStyles.lead}>Connect another Shopify store to U-Send in two steps.</p>
                <ol className={connectStyles.steps}>
                  <li>
                    <strong>Install U-Send on the store</strong>
                    <span>In the Shopify App Store, click Add app and then Install app on the authorization page.</span>
                  </li>
                  <li>
                    <strong>Link it to this account (optional)</strong>
                    <span>Go to Settings, Team and invite the e-mail of the new store as an admin. Then you can switch between stores.</span>
                  </li>
                </ol>
                <div className={connectStyles.actions}>
                  <button type="button" className={connectStyles.secondary} onClick={() => (handleCloseFn ? handleCloseFn() : handleClose())}>
                    Cancel
                  </button>
                  <a
                    href="https://apps.shopify.com/u-send"
                    target="_blank"
                    rel="noreferrer"
                    className={connectStyles.primary}
                    onClick={() => (handleCloseFn ? handleCloseFn() : handleClose())}
                  >
                    Open Shopify App Store
                  </a>
                </div>
              </div>
            ) : (
            <div className={globalStyles.p_20}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "60px",
                }}
              >
                <h2 style={{ marginRight: 15, fontWeight: 600 }}>
                  Add a new store to your account
                </h2>
                <div>
                  <img
                    src={
                      "https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png"
                    }
                    alt="shopifylogo"
                    style={{ width: "35px", height: "35px", marginTop: 10 }}
                  />
                </div>
              </div>
              <div
                style={{
                  margin: "50px 0px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={
                    {
                      // boxShadow: "0px 10px 15px 2px lightgray",
                      // borderRadius: "10px",
                      // width: "auto",
                      // padding: "12px 22px",
                    }
                  }
                >
                  <img
                    style={{ width: "50%" }}
                    src={shopifyAppLogo}
                    alt="store"
                  />
                </div>
              </div>
              {/* <p className={globalStyles.p_20}>
                Enter your existing Shopify store URL (store.myshopify.com) to
                start synchronizing the needed data from your Shopify store.
                After proceeding you will be redirected to Shopify to connect
                your store to the U-Send Platform.
              </p> */}

              <div>
                <div style={{ display: "flex", alignItems: "baseline" }}>
                  <div
                    style={{
                      background: "#D3C8EE",
                      borderRadius: "5px",
                      padding: "5px 20px",
                      marginRight: "30px",
                      display: "inline-block",
                    }}
                  >
                    <h5
                      style={{
                        color: "#9562F4",
                        fontSize: "16px",
                        margin: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Step 1.
                    </h5>
                  </div>
                  <div style={{ width: "auto", textAlign: "left" }}>
                    <h4>Install U-send to your store</h4>
                    <p>
                      From the Shopify app store, you can easily install the
                      U-send app on your Shopify by clicking on "Add app". You
                      will be taken to the authorization page and there click on
                      "install app"
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      background: "#D3C8EE",
                      borderRadius: "5px",
                      padding: "5px 20px",
                      marginRight: "30px",
                      width: "auto",
                    }}
                  >
                    <h5
                      style={{
                        color: "#9562F4",
                        fontSize: "16px",
                        width: "100%",
                        whiteSpace: "nowrap",
                        margin: 0,
                      }}
                    >
                      Step 2.
                    </h5>
                  </div>
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <h4>Link your new store to this account (optional)</h4>
                    <p>
                      You are now able to link your new store to this account as
                      well. Just go to Settings -{">"} Team -{">"} Add User.
                      From there, you can add the e-mail your new account is on
                      as an admin. After it has been added, you can easily
                      switch between stores.
                    </p>
                  </div>
                </div>
              </div>
              <div style={{ textAlign: "right", marginTop: "30px" }}>
                <IconButton
                  type="button"
                  sx={{
                    p: "10px",
                    "&.MuiIconButton-root": {
                      padding: 0,
                    },
                  }}
                  aria-label="search"
                >
                  <a
                    href="https://apps.shopify.com/u-send"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button
                      // className={classes.button}
                      variant="purple"
                      color="primary"
                      sx={{
                        width: "auto",
                        margin: 0,
                        zIndex: "99",
                        height: "45px",
                        color: "white",
                        marginLeft: "-8px",
                        borderRadius: "5px",
                      }}
                      // eslint-disable-next-line react/jsx-no-duplicate-props
                      onClick={() => {
                        // const findStore = storeInfo?.stores?.find(
                        //   (item) => item.store_name === store
                        // );
                        // if (findStore) {
                        //   toast.warn(
                        //     "The store is already connected to our portal"
                        //   );
                        //   handleClose()
                        // } else {
                        // }
                        //   dispatch(addStore({ store_name: store }));
                        handleCloseFn ? handleCloseFn() : handleClose();
                      }}
                    >
                      Connect
                    </Button>
                  </a>
                </IconButton>
              </div>
            </div>
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
